import CustomerModel from '@/models/Sale/SlCustomer'

/**
 *
 */
export default async customer_id => {
    //
    try {
        //
        const customers = await CustomerModel.include(
            'sl_ground_seller.hr_employee',
            'pch_payment_condition'
        )
            .append('branch_offices', 'discount')
            .find(customer_id)
        //
        return customers
    } catch (error) {
        //
        return error.response.data
    }
}
